'use strict';

exports.__esModule = true;
exports.asyncEachOf = asyncEachOf;
exports._setImmediate = _setImmediate;
exports.isUndefined = isUndefined;
exports.isPlainObject = isPlainObject;
exports.pathValue = pathValue;
exports.setValueByPath = setValueByPath;
exports.clone = clone;
exports.filterViasPromises = filterViasPromises;
exports.viasPromiseValue = viasPromiseValue;
exports.viasPromiseReason = viasPromiseReason;
exports.viasPromiseState = viasPromiseState;

var _ViasPromise = require('./ViasPromise');

var _ViasPromise2 = _interopRequireDefault(_ViasPromise);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Simplified version of async.eachOf
// Copied/modified util functions from async or lodash to reduce dependencies
function asyncEachOf(collection, handler, finalCallback) {
  var called = false;
  function cb(err) {
    if (!called) {
      called = true;
      finalCallback(err);
    }
  }
  var size = Object.keys(collection).length;
  if (size === 0) {
    return cb();
  }
  var finish = 0;
  function callback(err) {
    finish++;
    if (err) {
      return cb(err);
    }
    if (finish >= size) {
      return cb();
    }
  }
  for (var _iterator = Object.entries(collection), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var _ref2 = _ref,
        key = _ref2[0],
        item = _ref2[1];

    handler(item, key, callback);
  }
}

var _defer = void 0;
if (typeof setImmediate === 'function') {
  _defer = setImmediate;
} else if (typeof process === 'object' && typeof process.nextTick === 'function') {
  _defer = process.nextTick;
} else {
  _defer = function (fn) {
    setTimeout(fn, 0);
  };
}

function _setImmediate(fn) {
  _defer(fn);
}

function isUndefined(val) {
  return val === undefined;
}

function isPlainObject(value) {
  if (!value) {
    return false;
  }
  if (typeof value !== 'object') {
    return false;
  }

  var proto = Object.getPrototypeOf(Object(value));
  if (proto === null) {
    return true;
  }

  return proto.constructor && typeof proto.constructor === 'function' && proto.constructor instanceof proto.constructor && proto.constructor.toString() === Object.toString();
}

function toPath(string) {
  var result = [];
  if (/^\./.test(string)) {
    result.push('');
  }
  var prop = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  string.replace(prop, function (match, number, quote, string) {
    result.push(quote ? string.replace(/[\\^$.*+?()[\]{}|]/g, '$1') : number || match);
  });
  return result;
}

// _.get
function pathValue(object, pathStr) {
  var path = toPath(pathStr);
  var obj = object;
  for (var _iterator2 = path, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref3 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref3 = _i2.value;
    }

    var item = _ref3;

    if (!obj) {
      return undefined;
    }
    obj = obj[item];
  }
  return obj;
}

// _.set
function setValueByPath(object, pathStr, value) {
  var path = toPath(pathStr);
  var obj = object;
  var lastPath = path.pop();
  for (var _iterator3 = path, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref4 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref4 = _i3.value;
    }

    var item = _ref4;

    if (!obj) {
      throw new Error('Cannot access ' + pathStr);
    }
    obj = obj[item];
  }
  obj[lastPath] = value;
}

// Very hard to reimplement/copy cloneDeep
function clone(toClone) {
  return _lodash2.default.cloneDeep(toClone);
  // return JSON.parse(JSON.stringify(toClone));
}

function filterViasPromises(viasPromises) {
  if (viasPromises instanceof _ViasPromise2.default) {
    return viasPromises;
  }

  if (Array.isArray(viasPromises)) {
    return viasPromises.filter(function (vp) {
      return vp instanceof _ViasPromise2.default;
    });
  }

  if (isPlainObject(viasPromises)) {
    var results = {};
    for (var _iterator4 = Object.entries(viasPromises), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref5 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref5 = _i4.value;
      }

      var _ref6 = _ref5,
          key = _ref6[0],
          vp = _ref6[1];

      if (vp instanceof _ViasPromise2.default) {
        results[key] = vp;
      }
    }
    return results;
  }

  throw new Error('Invalid parameters');
}

function viasPromiseValue(viasPromises) {
  viasPromises = filterViasPromises(viasPromises);
  if (viasPromises instanceof _ViasPromise2.default) {
    return viasPromises.populate();
  }

  if (Array.isArray(viasPromises)) {
    return viasPromises.map(function (vp) {
      return vp.populate();
    });
  }

  if (isPlainObject(viasPromises)) {
    var result = {};
    for (var key in viasPromises) {
      if (viasPromises.hasOwnProperty(key)) {
        result[key] = viasPromises[key].populate();
      }
    }

    return result;
  }
  throw new Error('Invalid parameters');
}

function viasPromiseReason(viasPromises) {
  viasPromises = filterViasPromises(viasPromises);
  if (viasPromises instanceof _ViasPromise2.default) {
    return viasPromises.reason;
  }

  if (Array.isArray(viasPromises) || isPlainObject(viasPromises)) {
    var found = void 0;
    for (var _iterator5 = Object.entries(viasPromises), _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref7;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref7 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref7 = _i5.value;
      }

      var _ref8 = _ref7,
          promise = _ref8[1];

      if (promise.reason) {
        found = promise;
        break;
      }
    }
    return found && found.reason;
  }

  throw new Error('Invalid parameters');
}

function viasPromiseState(viasPromises) {
  viasPromises = filterViasPromises(viasPromises);
  if (viasPromises instanceof _ViasPromise2.default) {
    return {
      pending: viasPromises.pending,
      fulfilled: viasPromises.fulfilled,
      rejected: viasPromises.rejected
    };
  }

  if (Array.isArray(viasPromises) || isPlainObject(viasPromises)) {
    var promises = Object.values(viasPromises);
    return {
      pending: promises.some(function (p) {
        return p.pending;
      }),
      fulfilled: promises.every(function (p) {
        return p.fulfilled;
      }),
      rejected: promises.some(function (p) {
        return p.rejected;
      })
    };
  }

  throw new Error('Invalid parameters');
}


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/util.js
// module id = 45
// module chunks = 15